import { ApiError } from '../../api/client';
import { Card } from '../../components/arc/card/card';
import { PageState } from '../../components/arc/page-state/page-state';
import { getChannels, type ChannelCard } from '../../api/marketing';
import { useRondoPageData } from '../useRondoPageData';
import './marketing-channels-arc.css';

const FLAG: Record<string, string> = { CZ: '🇨🇿', SK: '🇸🇰', RO: '🇷🇴' };
const LINK_TAB: Record<string, string> = {
  'Odesílatelé': '?mkt=senders',
  'Mail šablony': '?mkt=mail',
  'Notif šablony': '?mkt=mail',
  'Modal šablony': '?mkt=modal',
  'Partneři (URL)': '?mkt=partners',
  'Shortener': '?view=shortener',
  'Landing domény': '?view=landing',
};
const CHANNEL_LINKS: Record<string, string[]> = {
  mail: ['Odesílatelé', 'Mail šablony', 'Partneři (URL)'],
  notif: ['Notif šablony'],
  modal: ['Modal šablony', 'Partneři (URL)'],
  sms: ['Shortener', 'Partneři (URL)'],
  lp: ['Landing domény'],
  wa: [],
};

export function MarketingKanalyPage() {
  const { data: cards, error, loading } = useRondoPageData<ChannelCard[]>('marketing-channels', getChannels);

  if (loading) return <PageState title="Načítám marketingové kanály" loading />;
  if (error) return <PageState title="Marketingové kanály se nepodařilo načíst" message={error instanceof ApiError ? error.message : 'Načtení selhalo'} />;
  if (!cards) return null;

  return <section className="rondo-marketing-page rondo-arc-marketing-channels p1-arc-scope">
    <header className="prototype-page-head"><div><div className="prototype-eyebrow rondo">MARKETING</div><h1>Kanály</h1><p>Dostupné komunikační kanály a jejich nastavení</p></div></header>
    <div className="rondo-arc-marketing-channel-grid">
      {cards.map((channel) => <Card title={channel.label} className="rondo-arc-marketing-channel-card" key={channel.key}>
        <span className="rondo-arc-marketing-channel-status" data-status={channel.status}>{channel.status === 'active' ? 'Aktivní' : 'Plánovaný'}</span>
        <div className="rondo-arc-marketing-channel-markets">
          {channel.countries.map((country) => <span key={country.code} data-active={country.active}>{FLAG[country.code] ?? ''} {country.code}</span>)}
        </div>
        {(channel.sendersCount != null || channel.templatesCount != null) && <p className="rondo-arc-marketing-channel-counts">
          {channel.sendersCount != null && <span>{channel.sendersCount} odesílatelů</span>}
          {channel.templatesCount != null && <span>{channel.templatesCount} šablon</span>}
        </p>}
        {(CHANNEL_LINKS[channel.key] ?? []).length > 0 && <div className="rondo-arc-marketing-channel-links">
          {(CHANNEL_LINKS[channel.key] ?? []).map((label) => <a href={`/nastaveni${LINK_TAB[label] ?? ''}`} key={label}>{label}</a>)}
        </div>}
      </Card>)}
    </div>
  </section>;
}
